import AnalyticsPoint from 'gatsby-plugin-purina-analytics/AnalyticsPoint';
import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductList from 'src/components/product_list/ProductList';
import { NodeProductProps } from '../types';

interface Props {
  relatedProducts: {
    edges: [
      {
        node: NodeProductProps;
      },
    ];
  };
}

const RelatedProducts: React.FC<Props> = ({ relatedProducts }) => {
  const { t } = useTranslation();
  const productList = relatedProducts.edges.map(product => product.node);

  return (
    <AnalyticsPoint
      as="div"
      type="module"
      typeLabel="product_related_products"
      label="related products"
      className="pds-space-y-4.5 pds-px-4 pds-py-5.5"
    >
      <h2 className="pds-mb-4 pds-ml-0 pds-text-title-sm pds-capitalize">
        {t('Discover similar products')}
      </h2>
      <ProductList
        productsList={productList}
        onClick={title => {
          sendIt({
            event: 'module_interaction',
            eventParams: {
              component_id: title,
              component_type: 'product_card',
              content_name: 'product_card: related',
            },
          });
        }}
      />
    </AnalyticsPoint>
  );
};

export default RelatedProducts;
